import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/core';
import { HighlightPipe } from '../pipes/highlight.pipe';
import { ZittingListComponent } from './zitting-list/zitting-list.component';
import { NotitieListComponent } from './notities/notitie-list/notitie-list.component';
import { RecenteNotitiesComponent } from './notities/recente-notities/recente-notities.component';
import { RouterModule } from '@angular/router';
import { DebugComponent } from './dev-debug/debug.component';
import { DocumentViewerComponent } from 'src/app/document-viewer/document-viewer.component';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { FocusMeDirective } from './focus.directive';
import { LoginComponent } from 'src/app/shared/login/login.component';
import { LoginModule } from '@cevi/cevi-ui-library/login';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgxExtendedPdfViewerModule,
        LoginModule,
        HighlightPipe,
        ZittingListComponent,
        NotitieListComponent,
        RecenteNotitiesComponent,
        DebugComponent,
        DocumentViewerComponent,
        FocusMeDirective,
        LoginComponent
    ],
    exports: [
        HighlightPipe,
        ZittingListComponent,
        NotitieListComponent,
        RecenteNotitiesComponent,
        DebugComponent,
        DocumentViewerComponent,
        FocusMeDirective
    ],
    providers: []
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }

}
